import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
// import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import socket from './socket';
//import VueSocketIO from 'vue-socket.io'
import axios from 'axios';
import VueAxios from 'vue-axios';
import vuetify from '@/plugins/vuetify';
import VueNoty from 'vuejs-noty';
import VueCookies from 'vue-cookies';
import Loading from 'vue-loading-overlay';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "../src/assets/main.scss";
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueRx from 'vue-rx'
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd.min'
import 'vuejs-clipper/dist/vuejs-clipper.css'

Vue.use(VueRx)
Vue.use(VuejsClipper)

import 'vuejs-noty/dist/vuejs-noty.css';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VueNoty);
Vue.use(VueCookies);
Vue.use(Loading);
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MMM DD, YYYY')
    }
});
//Vue.prototype.$socket = socket;

axios.interceptors.request.use(
  config => {
    var token;
      if(Vue.$cookies.get('userAccess') != null){
        token = `Bearer ${Vue.$cookies.get('userAccess')}` 
      }else if(Vue.$cookies.get('guestAccess') != null){
        token = `Bearer ${Vue.$cookies.get('guestAccess')}`
      }
      if (token) {
        config.headers.Authorization = `${token}`;
      }
      return config;
    }
);

axios.interceptors.response.use(
  config => {
    return config
  },
  error => {
    if(error.response.status == 401)
      if(process.env.VUE_APP_SERVER_TYPE == "SERVER"){
        Vue.$cookies.remove("userAccess", null, ".avishkaar.cc")
      }else{
        Vue.$cookies.remove("userAccess")
      }
    else if(error.response.status == 500)  
      Vue.noty.error("There is some technical error. Please try after some time")
    return Promise.reject(error);
  }
)

/*** Socket ***/
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: process.env.NODE_ENV === 'production' ? 'https://cloud.ircleague.com' : 'http://localhost:3000',
//   vuex: {
//       store,
//       actionPrefix: 'SOCKET_',
//       mutationPrefix: 'SOCKET_'
//   }
// }))

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
